<div class="provider-container">
  <ag-grid-angular
    class="ag-theme-balham-dark provider-container__ag-grid"
    [columnDefs]="columnDefs"
    rowSelection="multiple"
    [groupSelectsChildren]="true"
    [defaultColDef]="defaultColDef"
    [suppressRowClickSelection]="true"
    [sideBar]="undefined"
    (gridReady)="onGridReady($event)"
    (rowClicked)="rowClicked($event)"
    (selectionChanged)="selectionChanged()"
    (firstDataRendered)="firstDataRendered()"
  >
  </ag-grid-angular>
</div>

<div class="provider-container__footer">
  <div class="provider-container__footer__buttons">
    <button
      type="button"
      class="ui-button ui-button__footer"
      (click)="loadTrades()"
      [disabled]="!buttonsEnabled"
    >
      Load
    </button>
  </div>
</div>

<ui-modal
  [(isOpened)]="modalOpened"
  modalTitle="Please disable Trade View"
  size="md"
>
  <div class="body">
    Trades may need to be saved prior to disabling the trade view or changes
    will be lost.
  </div>
  <div class="footer-buttons">
    <button
      type="button"
      class="ui-button ui-button__footer"
      (click)="modalOpened = false"
    >
      OK
    </button>
  </div>
</ui-modal>
